/**
 * Pre-launch site configuration.
 *
 * LAUNCH_MODE gates the storefront off. While it is true only `/` and the
 * footer info pages are reachable; every commerce/auth route redirects to `/`.
 *
 * Flipping it to false restores the storefront — nothing was deleted. Note that
 * only the LAUNCH_MODE=true path is covered by src/LaunchMode.test.js, so give
 * the restored shop a pass by hand before trusting it. In particular Home now
 * lives at `/` rather than `/home`; any hardcoded `/home` link is stale.
 */
export const LAUNCH_MODE = true;

/**
 * FormSubmit (https://formsubmit.co) posts newsletter signups to this address.
 *
 * IMPORTANT: the FIRST submission sends an activation email to this address.
 * Nothing is delivered until that link is clicked — until then the form looks
 * fine and silently drops every signup.
 *
 * This address is visible in the built JS bundle. After activating, FormSubmit
 * gives you an obfuscated alias token; swap it in here to hide the real address.
 */
export const FORMSUBMIT_TARGET = 'albinj20@gmail.com';
export const FORMSUBMIT_URL = `https://formsubmit.co/ajax/${FORMSUBMIT_TARGET}`;

// TODO: replace with the real support address before launch.
export const SUPPORT_EMAIL = 'support@abayatique.com';

// TODO: replace with the real registered address before launch.
export const COMPANY_ADDRESS = 'Dubai, United Arab Emirates';

export const COMPANY_NAME = 'Abayatique';

// TODO: replace these placeholders with the real profile URLs before launch.
export const SOCIAL_LINKS = {
    facebook: 'https://www.facebook.com/abayatique',
    instagram: 'https://www.instagram.com/abayatique',
    twitter: 'https://www.twitter.com/abayatique',
    linkedin: 'https://www.linkedin.com/company/abayatique',
};
